import { TemplateData, TemplateParams } from '.';

const groupInvite = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'groups',
  email: {
    buttonEnabled: true,
    buttonLink: '{{siteUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.groupInviteAddedToGroupInfo}
        ${messages.groupInviteAccessCourses}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.courseFindAllCourses}
        ${
          serverConfig.authEnableLocalLogin &&
          !serverConfig.emailHidePasswordResetInfo
            ? messages.emailResetPasswordContent
            : ''
        }
      </p>
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.groupInviteAddedToGroup}`
  },
  placeholders: {
    groupTitle: {
      label: messages.groupsGroupTitle,
      example: 'Test group'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeGroupInvite
});

export default groupInvite;
